import Alerts from 'lib/alerts';
import PayrollDetailView from './PayrollDetail.js';
import tooltip from 'helpers/tooltip';
import loader from 'helpers/loader';
import PayrollItemSelectionModal from
    'employer/views/PayrollItemSelectionModal.js';
import template from 'employer/templates/payroll/stepOne/Employee.html';

module.exports = Backbone.View.extend({
    tagName:               'table',
    availablePayrollItems: null,
    payrollItemsModal:     null,
    detailViews:           null,

    events: function() {
        return {
            'click .js-add-item-button':         'showSelectModal',
            'click .js-use-last-payroll-button': 'reuseLastPayroll',
            'show':                              'onShow'
        };
    },

    initialize: function(options) {
        this.options = _.defaults(options || {}, {
            payroll: null,
            pendingJobs: false,
            payrollDetails: null,
            payrollItems: null,
            lastPayroll: null,
            lastPayrollDetails: null,
        });

        this.detailViews = [];

        this.availablePayrollItems = this.options.payrollItems.clone();
        this.updateItemAvailability();

        this.payrollItemsModal = new PayrollItemSelectionModal({
            collection: this.availablePayrollItems
        });

        this.bindHandlers();

        this.render();
    },

    bindHandlers: function() {
        this.payrollItemsModal.on('select', this.addItems, this);

        this.options.payrollDetails.on('add', this.renderDetail, this);
        this.options.payrollDetails.on('reset', this.renderDetails, this);
        this.options.payrollDetails.on('destroy remove', this.hideEmpty, this);
        this.options.payrollDetails.on(
            'add remove reset change:amount', this.renderNetAmount, this
        );
        this.options.payrollDetails.on(
            'add remove reset', this.updateItemAvailability, this
        );
    },

    unbindHandlers: function() {
        this.payrollItemsModal.off(null, null, this);
        this.options.payrollDetails.off(null, null, this);
    },

    render: function() {
        this.$el.addClass('invisible').html(template({
            model:              this.model,
            payroll:            this.options.payroll,
            payrollDetails:     this.options.payrollDetails,
            lastPayrollDetails: this.options.lastPayrollDetails ?
                this.options.lastPayrollDetails.filterByEmployee(
                    this.model.id, {collection: true}
                ) : null,
            isCard: this.$el.hasClass('js-is-card'),
            showButtons: (
                !this.options.payroll.get('running') &&
                !this.options.pendingJobs
            )
        }));

        this.renderDetails();

        this.renderNetAmount();

        tooltip.init(this);
    },

    onShow: function() {
        setTimeout(function() {
            this.$el.footable({
                sort: false,
                addRowToggle: !this.$el.hasClass('js-is-card'),
            }).trigger('footable_expand_all').removeClass('invisible');

            this.$('.footable-last-payroll-details').footable({
                sort: false,
                addRowToggle: true
            }).removeClass('invisible');

            this.$el.trigger('footable_expand_all');
        }.bind(this), 1);
    },

    renderDetail: function(model) {
        if (model.get('employeeId') !== this.model.id) {
            return;
        }

        const view = new PayrollDetailView({model: model});
        const $el =
            model.isAddition() ? this.$('.js-payroll-details-additions') :
                model.isDeduction() ? this.$('.js-payroll-details-deductions') :
                    model.isOther() ? this.$('.js-payroll-details-others') : null;

        if ($el) {
            this.detailViews.push(view);
            $el.append(view.$el).removeClass('hidden');
        }
    },

    renderDetails: function() {
        _.each(this.detailViews, function(view, i) {
            view.remove();
            delete this.detailViews[i];
        }.bind(this));
        this.detailViews = [];

        this.options.payrollDetails.filterByEmployee(this.model.id, {
            collection: true
        }).forEach(this.renderDetail.bind(this));
    },

    renderNetAmount: function(model) {
        if (
            model &&
            _.isObject(model.attributes) &&
            model.get('employeeId') !== this.model.id
        ) {
            return true;
        }

        this.$('.js-net-amount').val((
            this.options.payrollDetails.getNetAmount(this.model.id) || 0
        ).formatWithoutRounding());
    },

    addItems: function(payrollItems, additionalInfo) {
        if (
            this.options.payroll.get('running') ||
            this.options.pendingJobs
        ) {
            return;
        }

        return Promise.all(payrollItems.map(payrollItem => {
            const info = _.isObject(additionalInfo) ?
                (additionalInfo[payrollItem.id] || null) : null;

            this.options.payrollDetails.add({
                employeeId: this.model.id,
                payrollId: this.options.payroll.id,
                payrollItemId: payrollItem.id,
                isAdditional: true,
                rate: payrollItem.get('isUnit') ? 1 : null,
                unit: payrollItem.get('isUnit') ? 1 : null,
                additionalInformation: info
            }, {validate: false});

            return this.options.payrollDetails
                .createOvertimeInfoAfterAdd(this.model);
        }));
    },

    hideEmpty: function() {
        this.$('.js-payroll-details-additions').toggleClass(
            'hidden',
            !this.$('.js-payroll-details-additions tr:not(.title)').length
        );
        this.$('.js-payroll-details-deductions').toggleClass(
            'hidden',
            !this.$('.js-payroll-details-deductions tr:not(.title)').length
        );
    },

    reuseLastPayroll: function(ev) {
        ev.preventDefault();
        const $button = this.$(ev.currentTarget);
        const stopLoader = loader.startFullScreen($button);
        const lastDetails = this.options.lastPayrollDetails
            .filterByEmployee(this.model.id, {collection: true});

        if (
            this.options.payroll.get('running') ||
            this.options.pendingJobs
        ) {
            stopLoader();
            return;
        }

        if (lastDetails.length > 0) {
            this.options.payrollDetails.replace(
                lastDetails.reassignToPayroll(this.options.payroll.id),
                this.model.id
            ).then(() => this.options.payrollDetails
                .createOvertimeInfoAfterAdd(this.model)
            ).finally(stopLoader);
        } else {
            stopLoader();
            Alerts.show('warning', {
                title: '',
                text:  'There is no previous payroll for this employee'
            });
        }
    },

    showSelectModal: function(ev) {
        ev.preventDefault();

        if (
            this.options.payroll.get('running') ||
            this.options.pendingJobs
        ) {
            return;
        }

        this.payrollItemsModal.show();
    },

    updateItemAvailability: function() {
        const employeeDetails = this.options.payrollDetails.filterByEmployee(
            this.model.id
        );

        this.availablePayrollItems.reset(
            this.options.payrollItems.clone().filter(model =>
                employeeDetails.every(detail => {
                    const payrollItem = detail.getPayrollItem();
                    return ((payrollItem && payrollItem.id !== model.id) || 
                    (!_.isEmpty(detail.get('affectsItemId'))))
                })
            )
        );
    },

    remove: function() {
        Backbone.View.prototype.remove.apply(this, arguments);

        this.unbindHandlers();
        this.undelegateEvents();
        this.payrollItemsModal.remove();

        _.each(this.detailViews, function(view) {
            view.remove();
            view = null;
        });
    },

    lock: function() {
        this.unbindHandlers();
        this.undelegateEvents();
    },

    unlock: function() {
        // make sure it's locked first, to avoid duplicate handlers
        this.lock();

        this.bindHandlers();
        this.delegateEvents();
    }
});



// WEBPACK FOOTER //
// ./app/employer/views/payroll/stepOne/Employee.js